<template>
  <div>
    <Header></Header>
    <div class="banner-group"><img src="../assets/img/group/banner.jpg" alt=""></div>
    <div class="container">
      <div class="article">
        <span class="title">企业简介</span>
        <div class="article-desc">
          鲨鱼公园是中国青少年科技教育知名领先品牌，是一家专注于青少年STEM科学启蒙及分阶教育的企业。集教材教育课程研发、教育培训、网络课程开发和后台管理于一体，为校内、外及家庭3-15岁青少年提供动手科学产品及趣味性的学科线下校区和线上网络情景学习，设立的教育与开发研究中心长期参与国家科学课标教参编写，业务覆盖物理、化学、生物、地理、天文、技术、工程
          数学、社会实践等科学领域，同时，作为产、学、研一体化集团，以学习中心精彩课堂、家庭在线课程和科学人文营队这种独特的“厅、堂、户”教学模式为依托，所创办的“鲨鱼公园”是互联网上深受喜爱的教育品牌，旗下“
          <!--          <科学实验机器商店+智能科学互动乐园>”-->
          是鲨鱼公园打造“无人值守、机器销售、智能互动课堂”划时代创新教育新零售，引领2019年教育科技连锁楷模。
        </div>

        <div class="article-desc">
          鲨鱼公园由环球雅思教育上市集团创始人张永琪、ATA教育上市集团创始人马肖风、好未来上市集团创始人张邦鑫三位教育行业泰斗与一批中央美院王云飞、拉比盒子创始人崔巍巍等年轻翘楚联合创办。2014年开办“鲨鱼公园儿童大学”线上线下创新教育项目。遍布全国各城市的线下连锁运营中心共享丰富的教学管理经验，校区以授课新颖、教学质量高、深受行业和家长认可，并向全国各公立幼儿园、小学推出科学实践教育课程，将传统的科普、知识教育拓展到实践教育的层面，以“观察、实践、假设、结论”的科学教育方法，旨在提升青少年的逻辑思维能力，创造能力，沟通能力，合作能力，动手能力，观察认知能力等综合素质，并得到了各界的高度评价，荣膺北京多所公立名校“课后三点半”素质教育指定教学服务供应商。2014年10月获得凯旋基金和好未来上市教育集团联合战略投资。2016年获得清科和立思辰基金联合战略投资。
        </div>
      </div>

      <div class="article">
        <span class="title">创始人介绍</span>
        <div class="article-desc">
          纳斯达克教育上市集团创始人二次创业，创业团队包括：中国在美知名上市教育机构环球雅思教育集团、ATA教育集团和好未来（学而思）教育集团三位创始人；教育部、南京大学、南京师范大学专家组的产品和课程研发团队；北大清华央美博士、硕士和本科毕业生组成的动漫创作和电商运营团队。
        </div>
        <div class="article-img">
          <img src="../assets/img/group/11.jpg" alt="">
          <img src="../assets/img/group/7.jpg" alt="" style="margin-top:-0.2em;"></div>
      </div>
      <div class="article">
        <span class="title">企业荣誉</span>
        <div class="honor-li">
          <ul>
            <li>北京市教委基础教育处和市教育学会指定为北京幼儿园、小学提供科学教育实验工程</li>
            <li>2014-2018北京市政府社会服务教育资助项目</li>
            <li>北京市重点办公小学校“课后三点半”科技教学服务特邀优秀供应商</li>
            <li>北京市政府以及教委“城市科学节”优秀组织机构</li>
            <li>北京一线知名幼儿园科学团体培训优秀提供商</li>
            <li>2014年鲨鱼公园入选“新京报”第八届北京民办教育园丁奖优秀教研团队候选人名单</li>
            <li>国家新闻出版社署广电总局“原动力”动漫扶持项目</li>
            <li>2015搜狐教育年度创新项目</li>
            <li>2015新浪教育盛典在线教育路演季军</li>
            <li>2015中国最具投资价值企业50强</li>
            <li>2015中国连锁之星企业</li>
            <li>2015中美欧创客大赛综合一等奖</li>
            <li>2016年度十佳教育机构</li>
            <li>2016中国现代职业智慧众创空间联盟副理事长单位</li>
            <li>2016-2017在线教育品牌榜服务创新奖</li>
            <li>2017科学小记者培养基地</li>
            <li>2017中国连锁品牌领航奖</li>
            <li>2018校长邦TIME盛典中国教育影响人物“声名远扬”奖</li>
            <li>2015-2018中国高成长连锁行业连锁之星</li>
            <li>2018年度阳光招商教育准独角兽品牌</li>
            <li>2019中国教培业领军人物“伏龙凤雏”奖</li>
          </ul>
        </div>
        <div class="article-img"><img src="../assets/img/group/8.jpg" alt=""></div>
      </div>

      <div class="article">
        <span class="title">一展风采</span>
        <div class="article-img"><img src="../assets/img/group/9.jpg" alt=""></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'Group',
  components: {Header, Footer},
  data () {
    return {
      msg: 'Group'
    }
  }
}
</script>

<style>
  .banner-group{
    width:100%;
    height:auto;
    margin:0 auto;
    text-align:center;
    min-width:720px;
  }
  .banner-group img{
    width:100%;
  }
  .container{
    width:80%;
    height:auto;
    margin:0 auto;
    text-align:center;
  }
  .article{
    width:80%;
    height:auto;
    margin:0 auto;
    margin-top:3em;
  }
  .title{
    font-size:2em;
    font-weight: bold;
  }
  .article-desc{
    margin-top:2em;
    letter-spacing: 0.1em;
    text-align: left;
  }
  .article-img{
    margin:0 auto;
    margin-top:3em;
    text-align:center;
  }
  .article-img img{
    width:100%;
  }
  .honor-li{
    text-align: left;
    line-height: 2em;
    font-weight: bold;
    letter-spacing: 0.15em;
  }
  li{
    list-style-type:none
  }
</style>
